{
	"v": "5.9.0",
	"fr": 30,
	"ip": 0,
	"op": 150,
	"w": 600,
	"h": 80,
	"nm": "drmantea-ekg",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "ekg-trace",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [0, 0, 0]
				},
				"a": {
					"a": 0,
					"k": [0, 0, 0]
				},
				"s": {
					"a": 0,
					"k": [100, 100, 100]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"nm": "scroll",
					"it": [
						{
							"ty": "sh",
							"nm": "ecg-path",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, 40],
										[30, 40],
										[40, 32],
										[50, 40],
										[70, 40],
										[76, 44],
										[82, 10],
										[88, 52],
										[94, 40],
										[110, 40],
										[125, 30],
										[140, 40],
										[200, 40],
										[230, 40],
										[240, 32],
										[250, 40],
										[270, 40],
										[276, 44],
										[282, 10],
										[288, 52],
										[294, 40],
										[310, 40],
										[325, 30],
										[340, 40],
										[400, 40],
										[430, 40],
										[440, 32],
										[450, 40],
										[470, 40],
										[476, 44],
										[482, 10],
										[488, 52],
										[494, 40],
										[510, 40],
										[525, 30],
										[540, 40],
										[600, 40],
										[630, 40],
										[640, 32],
										[650, 40],
										[670, 40],
										[676, 44],
										[682, 10],
										[688, 52],
										[694, 40],
										[710, 40],
										[725, 30],
										[740, 40],
										[800, 40],
										[830, 40],
										[840, 32],
										[850, 40],
										[870, 40],
										[876, 44],
										[882, 10],
										[888, 52],
										[894, 40],
										[910, 40],
										[925, 30],
										[940, 40],
										[1000, 40],
										[1030, 40],
										[1040, 32],
										[1050, 40],
										[1070, 40],
										[1076, 44],
										[1082, 10],
										[1088, 52],
										[1094, 40],
										[1110, 40],
										[1125, 30],
										[1140, 40],
										[1200, 40]
									],
									"c": false
								}
							}
						},
						{
							"ty": "st",
							"nm": "stroke",
							"c": {
								"a": 0,
								"k": [0.114, 0.251, 0.929, 1]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 4
							},
							"lc": 2,
							"lj": 2
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"t": 0,
										"s": [0, 0],
										"o": {
											"x": [0],
											"y": [0]
										},
										"i": {
											"x": [1],
											"y": [1]
										}
									},
									{
										"t": 150,
										"s": [-600, 0]
									}
								]
							},
							"a": {
								"a": 0,
								"k": [0, 0]
							},
							"s": {
								"a": 0,
								"k": [100, 100]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							}
						}
					]
				}
			],
			"ip": 0,
			"op": 150,
			"st": 0,
			"bm": 0
		}
	]
}
